import { Component, Input, OnInit } from '@angular/core';
import { EaGridkyService } from '../ea-gridky.service';

export enum GridkyAreas {
  around,
  france,
}

export enum GridkyType {
  ephad = 'ephad',
  student = 'student',
  senior = 'senior',
  tourism = 'tourism',
  medical = 'medical',
  business = 'business',
  personal_residency = 'personal_residency',
  pinel = 'pinel',
}

@Component({
    selector: 'ea-gridky-header',
    templateUrl: './ea-gridky-header.component.html',
    styleUrls: ['./ea-gridky-header.component.scss'],
    standalone: false
})
export class EaGridkyHeaderComponent implements OnInit {
  @Input() showTypeSelection: boolean = true;
  @Input() eaGridkyService: EaGridkyService;
  GridkyAreas = GridkyAreas;
  GridkyType = GridkyType;
  loading = true;

  constructor() {}

  ngOnInit() {
    this.eaGridkyService.searchProductSubject.subscribe(
      () => (this.loading = true),
    );
    this.eaGridkyService.productChanged.subscribe(() => (this.loading = false));
  }

  onSituationDone(event) {
    let sub = this.eaGridkyService.find().subscribe(() => {
      sub.unsubscribe();
    });
  }

  get selectedArea(): GridkyAreas {
    return (
      this.eaGridkyService.filters && this.eaGridkyService.filters.selectedArea
    );
  }

  get selectedType(): GridkyType {
    return this.eaGridkyService.product
      ? this.eaGridkyService.product.lmnpType
        ? Array.isArray(this.eaGridkyService.product.lmnpType)
          ? this.eaGridkyService.product.lmnpType[0]
          : this.eaGridkyService.product.lmnpType
        : Array.isArray(this.eaGridkyService.product.projects)
          ? this.eaGridkyService.product.projects[0]
          : this.eaGridkyService.product.projects
      : this.eaGridkyService.filters
        ? this.eaGridkyService.filters.selectedType
        : null;
  }
}
